// import Select from "react-select";
import makeAnimated from "react-select/animated";
import { components } from 'react-select';

// import AsyncSelect from 'react-select/async';
import { useState, useEffect } from "react";
// import { getLevelThreeNestedData, getTagProperties } from "../../../utils/getNestedData"
import { findNonAssociatedElements } from "@/utils/frontend/associationOps";

import { humanizeString } from "@/utils/frontend/stringOps";
import useSelectStyles from "./Styles";
import dynamic from "next/dynamic";
import { useContext } from "react";
import { UIContext } from "@/contexts/UIContext";

const Select = dynamic(() => import("react-select"), {
  ssr: false,
});

const SocialTopicsAssociationSelect = ({ thisUser, callback, tagsTable, tagsLevel, zIndex, target, placeholder, isMulti=true, selectedParent, selectedParentTag, state, lang, presetTopics, defaultMenuIsOpen=false, menuIsOpen=false, setMenuIsOpen, onSkip }) => {

  // console.log("TAGSLEVEL@SOCIALTOPICSASSOCIATIONSELECT", tagsLevel)
  // console.log("TARGET@SOCIALTOPICSASSOCIATIONSELECT", target)
  // console.log("PRESETTOPICS@SOCIALTOPICSASSOCIATIONSELECT", presetTopics)

  
  // presetTopics is called from /feed/topics/Sourcing for example, this way the user has to have it included in the NewSocialPostCard when making a new post in that topic page.
  // Right now, presetTopics is one single obj, not an array


    const { supportModalOpen, setSupportModalOpen, sideNavbarPinned, setSideNavbarPinned, setError, setSuccess, hint, setHint } = useContext(UIContext);


  // console.log("TARGET@TagsAssociationSelect", target)
    //  console.log('tagstable,', tagsTable)
  const animatedComponents = makeAnimated();

  // const [data, setData] = useState(null);
const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);
  const [isClearable, setIsClearable] = useState(true);
  const [isSearchable, setIsSearchable] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRtl, setIsRtl] = useState(false);
  const [selectedTags, setSelectedTags] = useState();
  const [associatedTags, setAssociatedTags] = useState();

  // populate associatedTags with presetTopics if there are any, used in feed/topics/topicName
  useEffect(() => {
    if (presetTopics){
      // console.log("GOT PRESET TOPICS")
      setAssociatedTags({...presetTopics, label: presetTopics.topic_name_en, label_en: presetTopics.topic_name_en, topic_level: presetTopics.topic_level, topic_uuid: presetTopics.uuid, value: presetTopics.topic_name_en, isFixed:true})
      callback({'lvlOne': {newTags: [{...presetTopics}]}});
    }
  }, [presetTopics])
  
  // console.log("SelectedParent", selectedParent)
  useEffect(() => {


    // if (target && target.tag) {
    //   // console.log('tarTAgs', target.tags)
    //   let tagsAssociated = [];
   
    //     tagsAssociated.push({ value: target.tag.topic_name_en, label: target.tag.topic_name_en, topic_name_en: target.tag.topic_name_en, tag_name_fr: target.tag.tag_name_fr, topic_level: target.tag.topic_level, topic_colors: target.tag.topic_colors, tag_id: target.tag.tag_id, topic_uuid: target.tag.topic_uuid });

    //   setAssociatedTags(tagsAssociated);
    // }





      if (target && target.topics) {
        // console.log('tarTAgs', target.tags)
        let tagsAssociated = [];
        for (let tag of target.topics) {
            tagsAssociated.push({ value: tag.topic_name_en, label: tag.topic_name_en, topic_name_en: tag.topic_name_en, topic_name_fr: tag.topic_name_fr, topic_level: tag.topic_level, topic_colors: tag.topic_colors, tag_id: tag.id, uuid: tag.uuid, 
          })
          // v1 - deprecated - comparing tagLevel
          // if (tag.topic_level === tagsLevel){tagsAssociated.push({ value: tag.topic_name_en, label: tag.topic_name_en, topic_name_en: tag.topic_name_en, topic_name_fr: tag.topic_name_fr, topic_level: tag.topic_level, topic_colors: tag.topic_colors, tag_id: tag.id, uuid: tag.uuid, 

          //   // tag_snapshot: { //this here is only used for JobPreviewCard
          //   //   value: tag.tag_snapshot.topic_name_en, label: tag.tag_snapshot.topic_name_en, topic_name_en: tag.tag_snapshot.topic_name_en, tag_name_fr: tag.tag_snapshot.tag_name_fr, topic_level: tag.tag_snapshot.topic_level, topic_colors: tag.tag_snapshot.topic_colors, tag_id: tag.tag_id, topic_uuid: tag.topic_uuid,
          //   // }
          //  });}
        }
        setAssociatedTags(tagsAssociated);
      }



    // uncomment if above go wrong
    // if (target && target.tags) {
    //   // console.log('tarTAgs', target.tags)
    //   let tagsAssociated = [];
    //   for (let tag of target.tags) {
    //     if (tag.tag_snapshot.topic_level === tagsLevel){tagsAssociated.push({ value: tag.tag_snapshot.topic_name_en, label: tag.tag_snapshot.topic_name_en, topic_name_en: tag.tag_snapshot.topic_name_en, tag_name_fr: tag.tag_snapshot.tag_name_fr, topic_level: tag.tag_snapshot.topic_level, topic_colors: tag.tag_snapshot.topic_colors, tag_id: tag.tag_id, topic_uuid: tag.topic_uuid, 

    //       tag_snapshot: { //this here is only used for JobPreviewCard
    //         value: tag.tag_snapshot.topic_name_en, label: tag.tag_snapshot.topic_name_en, topic_name_en: tag.tag_snapshot.topic_name_en, tag_name_fr: tag.tag_snapshot.tag_name_fr, topic_level: tag.tag_snapshot.topic_level, topic_colors: tag.tag_snapshot.topic_colors, tag_id: tag.tag_id, topic_uuid: tag.topic_uuid,
    //       }
    //      });}
    //   }
    //   setAssociatedTags(tagsAssociated);
    // }

    const getData = async () => {
      // console.log("TAGSLEVEL@GETDATA", tagsLevel)
      try {
        // Only display division (selectedParent) relevant tags 
        // if (Number(selectedParent)){
        // tagsTable = await tagsTable.filter(tag=> tag.tag_sector_industry.id === selectedParent || tag.tag_sector_industry.id === 0)
        // }
        // else {
        //   tagsTable = []
        // }

        let tagMenuOptions = tagsTable?.filter((tag) => {
           // if tagsLevel is passed as an argument, filter tags to match tagsLevel, otherwise, return all tags
          if (tagsLevel) {
            return tag.topic_level === tagsLevel
          } else {
            return tag
          }}).map((tag) => {
            return {
              // key: tag.tag_snapshot.topic_name_en,
              // id: tag.id,
              uuid: tag.uuid,
              value: tag.topic_name_en,
              label: tag.topic_name_en,
              topic_name_en: tag.topic_name_en,
              topic_name_fr: tag.topic_name_fr,
              topic_level: tag.topic_level,
              topic_colors: tag.topic_colors,
              topic_uuid: tag.topic_uuid,
              topic_description: tag.topic_description,
              topic_position: tag.topic_position,

              tag_snapshot: { // only used for JobPreviewCard, just like the redundancy above         
                // id: tag.id,
              value: tag.topic_name_en,
              label: tag.topic_name_en,
              topic_name_en: tag.topic_name_en,
              tag_name_fr: tag.tag_name_fr,
              topic_level: tag.topic_level,
              topic_colors: tag.topic_colors,
              topic_uuid: tag.topic_uuid,}
            };
          });

          tagMenuOptions = tagMenuOptions.sort((a, b) => Number(a.topic_position) - Number(b.topic_position))

          // add possibility to skip tag level starting at tags level 2 
          // tagsLevel > 1 && tagMenuOptions.unshift({
          //   value: "SKIP",
          //   label: "SKIP",
          //   isSkip: true,
          // });
          setData(await tagMenuOptions);
 


        
        // console.log("SELPAR", selectedParent)
        // if (selectedParent === 'FINANCE') { 
        //   // console.log("HERE")
        //   // tagMenuOptions = await tagMenuOptions.filter(tag=>tag.tag_sector_industry.id === 2)
        //   setData(await tagMenuOptions)
        // }
      } catch (error) {
        console.log("error", error);
      }

    };

    getData();



  // }, [target, tagsTable, selectedTags, selectedParent]);
  }, [target, tagsTable, tagsLevel, selectedTags, selectedParent]);

  const handleChange = async (newTags) => {


    // Skip the current topic dimension and advance to the next
    // v1
    // const skipSelected = Array.isArray(newTags)
    //   ? newTags.some(tag => tag.isSkip)
    //   : newTags?.isSkip;
    // if (skipSelected) {
    //   setMenuIsOpen(false);
    //   setCurrentSocialTopicsLevel(prev => Math.min(prev + 1, 4));
    //   return;
    // }
    // v2
      // const skipSelected = Array.isArray(newTags)
      //   ? newTags.some(tag => tag.isSkip)
      //   : newTags?.isSkip;
      // if (skipSelected) {
      //   onSkip?.();
      //   return;
      // }

    let totalLevel1Tags = Array.isArray(newTags) ? newTags.filter(tag=>tag.topic_level === 1).length : 0
    let totalLevel2Tags = Array.isArray(newTags) ? newTags.filter(tag=>tag.topic_level === 2).length : 0
    let totalLevel3Tags = Array.isArray(newTags) ? newTags.filter(tag=>tag.topic_level === 3).length : 0
    let totalLevel4Tags = Array.isArray(newTags) ? newTags.filter(tag=>tag.topic_level === 4).length : 0

    // if more than 2 level 1 tags are selected, don't add any more tags and raise an alert
    if (totalLevel1Tags > 1 && thisUser?.user_roles?.role !== 'ROOT') {
      setError({message: 'You can only select 1 area topic per post'})
      return false;
    }

    // if more than 3 level 2 tags are selected, don't add any more tags and raise an alert
    if (totalLevel2Tags > 3) {
      setError({message: 'You can only select 1 focus topic per post'})
      return false;
    }

    // if more than 1 level 4 (intent) tags are selected, don't add any more tags and raise an alert
    if (totalLevel4Tags > 1) {
      setError({message: 'You can only select 1 intent topic per post'})
      return false;
    }

    


    setSelectedTags({ ...selectedTags, newTags });
    // setSelectedTags(selectedTags => [...selectedTags, ...newTags]);
    // console.log('selectedTags@TagsAssociationSelect', selectedTags)

    await callback({[
      tagsLevel === 1 ? 'lvlOne' : 
      tagsLevel === 2 ? 'lvlTwo' : 
      tagsLevel === 3 ? 'lvlThree' : 
      'lvlFour' || 'tags']: {...selectedTags, newTags }});
    // await callback([...selectedTags, ...newTags]);
  };

//   const getValue = () => {
//      return target?.tags.map(tag => {return {value: 's', label: 's'}})
//   }
// target?.tags.map(tag => {return {value: tag.topic_name_en, label: tag.topic_name_en}}
  
const MultiValueRemove = (props) => {
  if (props.data.isFixed) {
    return null;
  }
  return <components.MultiValueRemove {...props} />;
};

return (
    <>



      <Select
        isMulti={isMulti}
        className="font-inter text-base font-normal"
        // className={`
        // dark:bg-inherit appearance-none inner-shadow rounded px-0 text-gray-700 leading-tight focus:outline-none focus:shadow-outline place-items-start bg-inherit`}
        
        classNamePrefix="select"
        value={selectedTags ? selectedTags.newTags : associatedTags}
        isDisabled={isDisabled}
        isLoading={isLoading}
        isClearable={isClearable}
        isRtl={isRtl}
        isSearchable={isSearchable}
        name="currentCompany"
        id="currentCompany"
        onChange={(tag) => {
          handleChange(tag);
        }}
        
        // value={value}
        options={data}
        components={{MultiValueRemove}}
        menuPlacement="bottom"
        styles={useSelectStyles(null, null, 'TOPICS')}
        placeholder={placeholder}
        defaultMenuIsOpen={defaultMenuIsOpen}
        menuIsOpen={menuIsOpen}
        // onMenuOpen={() => setMenuIsOpen(true)}
        // onMenuClose={() => setMenuIsOpen(false)}\
        onMenuOpen={() => setMenuIsOpen?.(true)}
        onMenuClose={() => setMenuIsOpen?.(false)}
      />

      {/*
          <div
            style={{
              color: 'hsl(0, 0%, 40%)',
              display: 'inline-block',
              fontSize: 12,
              fontStyle: 'italic',
              marginTop: '1em',
            }}
          >
            <Checkbox
              checked={isClearable}
              onChange={() => setIsClearable((state) => !state)}
            >
              Clearable
            </Checkbox>
            <Checkbox
              checked={isSearchable}
              onChange={() => setIsSearchable((state) => !state)}
            >
              Searchable
            </Checkbox>
            <Checkbox
              checked={isDisabled}
              onChange={() => setIsDisabled((state) => !state)}
            >
              Disabled
            </Checkbox>
            <Checkbox
              checked={isLoading}
              onChange={() => setIsLoading((state) => !state)}
            >
              Loading
            </Checkbox>
            <Checkbox checked={isRtl} onChange={() => setIsRtl((state) => !state)}>
              RTL
            </Checkbox> 
          </div>
          */}
    </>
    //      <>

    // <Select className="w-full mb-4 shadow appearance-none border rounded py-2 px-3 mx-5 text-gray-700 leading-tight focus:outline-none focus:shadow-outline place-items-start"
    // closeMenuOnSelect={false}
    // components={animatedComponents}
    // // defaultValue={[options[4], options[5]]}
    // isMulti
    // options={data}
    // />
    // </>
  );
};

export default SocialTopicsAssociationSelect;




































//   <Select
//   // defaultValue={[colourOptions[2], colourOptions[3]]}
//   isMulti
//   name="colors"
//   options={data}
//   className="basic-multi-select"
//   classNamePrefix="select"
// />







// import Select from "react-select";
// import makeAnimated from "react-select/animated";
// // import AsyncSelect from 'react-select/async';
// import { useState, useEffect } from "react";
// // import { getLevelThreeNestedData, getTagProperties } from "../../../utils/getNestedData"
// import { findNonAssociatedElements } from "@/utils/frontend/associationOps";
// import Styles from "./Styles";
// import { humanizeString } from "@/utils/frontend/stringOps";
// const TagsAssociationSelect = ({ callback, tagsTable, tagsType, zIndex, target, placeholder }) => {
//   // console.log("TARGET@TagsAssociationSelect", target)
//     //  console.log('tagstable,', tagsTable)
//   const animatedComponents = makeAnimated();

//   const [data, setData] = useState(null);

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [isClearable, setIsClearable] = useState(true);
//   const [isSearchable, setIsSearchable] = useState(true);
//   const [isDisabled, setIsDisabled] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isRtl, setIsRtl] = useState(false);
//   const [selectedTags, setSelectedTags] = useState();
//   const [associatedTags, setAssociatedTags] = useState();

//   useEffect(() => {

//     if (target && target.tags) {
//       let tagsAssociated = [];
//       for (let tag of target.tags) {
//         if (tag.tag_type === tagsType){tagsAssociated.push({ value: tag.topic_name_en, label: tag.topic_name_en, topic_name_en: tag.topic_name_en, tag_type: tag.tag_type, topic_colors: tag.topic_colors, tag_id: tag.tag_id, topic_uuid: tag.topic_uuid });}
//       }
//       setAssociatedTags(tagsAssociated);
//     }

//     const getData = async () => {
//       try {

    
//         let tagMenuOptions =  tagsTable?.filter((tag) => {
//            // if tagsType is passed as an argument, filter tags to match tagsType, otherwise, return all tags
//           if (tagsType) {
//             return tag.tag_type === tagsType
//           } else {
//             return tag
//           }})
//           .map((tag) => {
//             return {
//               id: tag.id,
//               value: tag.topic_name_en,
//               label: tag.topic_name_en,
//               topic_name_en: tag.topic_name_en,
//               tag_type: tag.tag_type,
//               topic_colors: tag.topic_colors,
//               topic_uuid: tag.topic_uuid,
//             };
//           });
//         setData(await tagMenuOptions);
//      //    setLoading(false)
//       } catch (error) {
//         console.log("error", error);
//       }

//       // try {
//       // const allTags = await axios.get(`/tags/`);
//       // let allTagsData = allTags.data;
//       // const associatedTags = await axios.get(`/people/tags/filter/person/${person.id}`)
//       // let associatedTagsData = associatedTags.data

//       // callback({associatedTags: getTagProperties(axios, associatedTagsData)})

//       // const nonAssociatedTags = findNonAssociatedElements(allTagsData, 'id', associatedTagsData, 'tag_id')

//       // let tagMenuOptions = nonAssociatedTags.filter(tag=>tag.tag_type === tagsType).map(tag => {
//       //   return {id: tag.id,  value: tag.topic_name_en, label: tag.topic_name_en, name: tag.topic_name_en, type:tag.tag_type, colors:tag.topic_colors, topic_uuid: tag.topic_uuid}
//       // })

//       // setData(tagMenuOptions);
//       // setError(null);
//       // return tagMenuOptions
//       // } catch(error) {
//       // setError(error.message);
//       // setData(null);
//       // } finally {
//       // setLoading(false);
//       // }
//     };

//     getData();


//   }, [target, tagsTable, selectedTags]);

//   const handleChange = async (newTags) => {
//     setSelectedTags({ ...selectedTags, newTags });
//     // setSelectedTags(selectedTags => [...selectedTags, ...newTags]);
//     console.log('selectedTags@TagsAssociationSelect', selectedTags)
//     await callback({[tagsType || 'tags']: {...selectedTags, newTags }});
//     // await callback([...selectedTags, ...newTags]);

//   };

// //   const getValue = () => {
// //      return target?.tags.map(tag => {return {value: 's', label: 's'}})
// //   }
// // target?.tags.map(tag => {return {value: tag.topic_name_en, label: tag.topic_name_en}}
//   return (
//     <>

//       <Select
//         isMulti
//         // className={`
//         // dark:bg-inherit appearance-none inner-shadow rounded px-0 text-gray-700 leading-tight focus:outline-none focus:shadow-outline place-items-start bg-inherit`}
        
//         classNamePrefix="select"
//         value={selectedTags?.newTags || associatedTags}
//         isDisabled={isDisabled}
//         isLoading={isLoading}
//         isClearable={isClearable}
//         isRtl={isRtl}
//         isSearchable={isSearchable}
//         name="currentCompany"
//         id="currentCompany"
//         onChange={(tag) => {
//           handleChange(tag);
//         }}
//         // value={value}
//         options={data}
//         components={animatedComponents}
//         menuPlacement="bottom"
//         styles={Styles()}
//         placeholder={placeholder}
//       />

//       {/*
//           <div
//             style={{
//               color: 'hsl(0, 0%, 40%)',
//               display: 'inline-block',
//               fontSize: 12,
//               fontStyle: 'italic',
//               marginTop: '1em',
//             }}
//           >
//             <Checkbox
//               checked={isClearable}
//               onChange={() => setIsClearable((state) => !state)}
//             >
//               Clearable
//             </Checkbox>
//             <Checkbox
//               checked={isSearchable}
//               onChange={() => setIsSearchable((state) => !state)}
//             >
//               Searchable
//             </Checkbox>
//             <Checkbox
//               checked={isDisabled}
//               onChange={() => setIsDisabled((state) => !state)}
//             >
//               Disabled
//             </Checkbox>
//             <Checkbox
//               checked={isLoading}
//               onChange={() => setIsLoading((state) => !state)}
//             >
//               Loading
//             </Checkbox>
//             <Checkbox checked={isRtl} onChange={() => setIsRtl((state) => !state)}>
//               RTL
//             </Checkbox> 
//           </div>
//           */}
//     </>
//     //      <>

//     // <Select className="w-full mb-4 shadow appearance-none border rounded py-2 px-3 mx-5 text-gray-700 leading-tight focus:outline-none focus:shadow-outline place-items-start"
//     // closeMenuOnSelect={false}
//     // components={animatedComponents}
//     // // defaultValue={[options[4], options[5]]}
//     // isMulti
//     // options={data}
//     // />
//     // </>
//   );
// };

// export default TagsAssociationSelect;

// //   <Select
// //   // defaultValue={[colourOptions[2], colourOptions[3]]}
// //   isMulti
// //   name="colors"
// //   options={data}
// //   className="basic-multi-select"
// //   classNamePrefix="select"
// // />















































// import Select from "react-select";
// import makeAnimated from "react-select/animated";
// // import AsyncSelect from 'react-select/async';
// import { useState, useEffect } from "react";
// // import { getLevelThreeNestedData, getTagProperties } from "../../../utils/getNestedData"
// import { findNonAssociatedElements } from "@/utils/frontend/associationOps";
// import Styles from "./Styles";
// import { humanizeString } from "@/utils/frontend/stringOps";
// const TagsAssociationSelect = ({ callback, tagsTable, tagsLevel, zIndex, target, placeholder }) => {
//   // console.log("TARGET@TagsAssociationSelect", target)
//     //  console.log('tagstable,', tagsTable)
//   const animatedComponents = makeAnimated();

//   const [data, setData] = useState(null);

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [isClearable, setIsClearable] = useState(true);
//   const [isSearchable, setIsSearchable] = useState(true);
//   const [isDisabled, setIsDisabled] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isRtl, setIsRtl] = useState(false);
//   const [selectedTags, setSelectedTags] = useState();
//   const [associatedTags, setAssociatedTags] = useState();

//   useEffect(() => {

//     if (target && target.tags) {
//       // console.log('tarTAgs', target.tags)
//       let tagsAssociated = [];
//       for (let tag of target.tags) {
//         if (tag.topic_level === tagsLevel){tagsAssociated.push({ value: tag.tag_name, label: tag.tag_name, tag_name: tag.tag_name, topic_level: tag.topic_level, topic_colors: tag.topic_colors, tag_id: tag.tag_id, topic_uuid: tag.topic_uuid });}
//       }
//       setAssociatedTags(tagsAssociated);
//     }

//     const getData = async () => {
//       try {

    
//         let tagMenuOptions =  tagsTable?.filter((tag) => {
//            // if tagsLevel is passed as an argument, filter tags to match tagsLevel, otherwise, return all tags
//           if (tagsLevel) {
//             return tag.topic_level === tagsLevel
//           } else {
//             return tag
//           }})
//           .map((tag) => {
//             return {
//               id: tag.id,
//               value: tag.tag_name,
//               label: tag.tag_name,
//               tag_name: tag.tag_name,
//               topic_level: tag.topic_level,
//               topic_colors: tag.topic_colors,
//               topic_uuid: tag.topic_uuid,
//             };
//           });
//         setData(await tagMenuOptions);
//      //    setLoading(false)
//       } catch (error) {
//         console.log("error", error);
//       }

//       // try {
//       // const allTags = await axios.get(`/tags/`);
//       // let allTagsData = allTags.data;
//       // const associatedTags = await axios.get(`/people/tags/filter/person/${person.id}`)
//       // let associatedTagsData = associatedTags.data

//       // callback({associatedTags: getTagProperties(axios, associatedTagsData)})

//       // const nonAssociatedTags = findNonAssociatedElements(allTagsData, 'id', associatedTagsData, 'tag_id')

//       // let tagMenuOptions = nonAssociatedTags.filter(tag=>tag.topic_level === tagsLevel).map(tag => {
//       //   return {id: tag.id,  value: tag.tag_name, label: tag.tag_name, name: tag.tag_name, type:tag.topic_level, colors:tag.topic_colors, topic_uuid: tag.topic_uuid}
//       // })

//       // setData(tagMenuOptions);
//       // setError(null);
//       // return tagMenuOptions
//       // } catch(error) {
//       // setError(error.message);
//       // setData(null);
//       // } finally {
//       // setLoading(false);
//       // }
//     };

//     getData();


//   }, [target, tagsTable, selectedTags]);

//   const handleChange = async (newTags) => {
//     setSelectedTags({ ...selectedTags, newTags });
//     // setSelectedTags(selectedTags => [...selectedTags, ...newTags]);
//     console.log('selectedTags@TagsAssociationSelect', selectedTags)
//     await callback({[tagsLevel === 1 ? 'lvlOne' : tagsLevel === 2 ? 'lvlTwo' : 'lvlThree' || 'tags']: {...selectedTags, newTags }});
//     // await callback([...selectedTags, ...newTags]);
//   };

// //   const getValue = () => {
// //      return target?.tags.map(tag => {return {value: 's', label: 's'}})
// //   }
// // target?.tags.map(tag => {return {value: tag.tag_name, label: tag.tag_name}}
//   return (
//     <>

//       <Select
//         isMulti
//         // className={`
//         // dark:bg-inherit appearance-none inner-shadow rounded px-0 text-gray-700 leading-tight focus:outline-none focus:shadow-outline place-items-start bg-inherit`}
        
//         classNamePrefix="select"
//         value={selectedTags?.newTags || associatedTags}
//         isDisabled={isDisabled}
//         isLoading={isLoading}
//         isClearable={isClearable}
//         isRtl={isRtl}
//         isSearchable={isSearchable}
//         name="currentCompany"
//         id="currentCompany"
//         onChange={(tag) => {
//           handleChange(tag);
//         }}
//         // value={value}
//         options={data}
//         // components={animatedComponents}
//         menuPlacement="bottom"
//         styles={Styles()}
//         placeholder={placeholder}
//       />

//       {/*
//           <div
//             style={{
//               color: 'hsl(0, 0%, 40%)',
//               display: 'inline-block',
//               fontSize: 12,
//               fontStyle: 'italic',
//               marginTop: '1em',
//             }}
//           >
//             <Checkbox
//               checked={isClearable}
//               onChange={() => setIsClearable((state) => !state)}
//             >
//               Clearable
//             </Checkbox>
//             <Checkbox
//               checked={isSearchable}
//               onChange={() => setIsSearchable((state) => !state)}
//             >
//               Searchable
//             </Checkbox>
//             <Checkbox
//               checked={isDisabled}
//               onChange={() => setIsDisabled((state) => !state)}
//             >
//               Disabled
//             </Checkbox>
//             <Checkbox
//               checked={isLoading}
//               onChange={() => setIsLoading((state) => !state)}
//             >
//               Loading
//             </Checkbox>
//             <Checkbox checked={isRtl} onChange={() => setIsRtl((state) => !state)}>
//               RTL
//             </Checkbox> 
//           </div>
//           */}
//     </>
//     //      <>

//     // <Select className="w-full mb-4 shadow appearance-none border rounded py-2 px-3 mx-5 text-gray-700 leading-tight focus:outline-none focus:shadow-outline place-items-start"
//     // closeMenuOnSelect={false}
//     // components={animatedComponents}
//     // // defaultValue={[options[4], options[5]]}
//     // isMulti
//     // options={data}
//     // />
//     // </>
//   );
// };

// export default TagsAssociationSelect;

// //   <Select
// //   // defaultValue={[colourOptions[2], colourOptions[3]]}
// //   isMulti
// //   name="colors"
// //   options={data}
// //   className="basic-multi-select"
// //   classNamePrefix="select"
// // />
